export default __webpack_public_path__ + "static/media/signapore-flag.e65ca2bf.svg";